import { render } from "./FormDatCatalogo.vue?vue&type=template&id=14dce23c&scoped=true"
import script from "./FormDatCatalogo.vue?vue&type=script&lang=js"
export * from "./FormDatCatalogo.vue?vue&type=script&lang=js"

import "./FormDatCatalogo.vue?vue&type=style&index=0&id=14dce23c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-14dce23c"

export default script